var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarTodoLine = function SvgCalendarTodoLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17 3.9h3.6a.9.9 0 0 1 .9.9v14.4a.9.9 0 0 1-.9.9H4.4a.9.9 0 0 1-.9-.9V4.8a.9.9 0 0 1 .9-.9H8V2.1h1.8v1.8h5.4V2.1H17zM5.3 9.3v9h14.4v-9zm1.8 1.8h1.8v1.8H7.1zm0 3.6h1.8v1.8H7.1zm3.6-3.6h7.2v1.8h-7.2zm0 3.6h4.5v1.8h-4.5z"
  })));
};
export default SvgCalendarTodoLine;